'use client';

import { SpotMarketConfig } from '@velocity-exchange/sdk';
import React from 'react';
import Button from 'src/components/primitives/Button/Button';
import ResponsiveModal from 'src/components/Modals/ResponsiveModal/ResponsiveModal';
import StakeFormContent from 'src/components/Staking/StakeFormContent';
import useStakeForm from 'src/components/Staking/hooks/useStakeForm';

interface Props {
	onConfirm: () => void;
	isVelocityStaking: boolean | undefined;
	selectedIfStakeMarket: SpotMarketConfig;
}

const StakeModalContent = ({
	onConfirm,
	isVelocityStaking,
	selectedIfStakeMarket: defaultSelectedMarket,
}: Props) => {
	const {
		isSubmitDisabled,
		isSubmitting,
		handleSubmit,
		submitButtonContent,
		...stakeFormProps
	} = useStakeForm({
		isVelocityStaking,
		defaultSelectedMarket,
		onConfirm,
	});

	return (
		<>
			<ResponsiveModal.Body>
				<StakeFormContent
					isVelocityStaking={isVelocityStaking}
					isSubmitting={isSubmitting}
					{...stakeFormProps}
				/>
			</ResponsiveModal.Body>
			<ResponsiveModal.Footer>
				<Button
					size="md"
					className="w-full"
					disabled={isSubmitDisabled}
					isLoading={isSubmitting}
					onClick={handleSubmit}
				>
					{submitButtonContent}
				</Button>
			</ResponsiveModal.Footer>
		</>
	);
};

export default React.memo(StakeModalContent);
